<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.create_user_realname}}_费用报销申请</template>

			<template #info>
				<c-field label="单据编号">{{baseInfo.document_number}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="报销类型"><c-state dict="reimbursementTypeDic" :value="baseInfo.reimbursement_type"></c-state></c-field>
			<c-field v-if="baseInfo.reimbursement_type == 1" label="关联工单"><c-link @click="mp.navigateWeb('/aftersales/work/detail', {id: baseInfo.order_id})">{{baseInfo.order_number}}</c-link></c-field>
            <c-field label="所在公司">{{baseInfo.company_name || '-'}}</c-field>
            <c-field v-if="baseInfo.reimbursement_type == 1" label="服务单据">
				<c-file-list :value="baseInfo.receipts_image_url"></c-file-list>
			</c-field>
			<c-field v-if="baseInfo.reimbursement_type == 1" label="拉力报告">
				<c-file-list :value="baseInfo.report_image_url"></c-file-list>
			</c-field>
			<c-field label="报销明细" vertical>
				<detail-card v-for="(item, i) in baseInfo.items" :key="i" :index="i + 1" :count-data="{name: '报销金额', value: `￥${item.item_amount}`}">
					<c-field label="报销项类型">
						<c-state dict="expenseItemTypeDic" :value="item.item_type"></c-state>
					</c-field>
					<c-field label="报销项">
						<c-state async dict="COMMONEXPENSE_ITEM" :value="item.item_code"></c-state>
					</c-field>
					<c-field label="开始日期">{{item.start_date}}</c-field>
					<c-field label="结束日期">{{item.end_date}}</c-field>
					<c-field label="报销金额">￥{{item.item_amount}}</c-field>
					<c-field v-if="baseInfo.reimbursement_type == 1" label="报销人">{{item.reimburser_name}}</c-field>
					<c-field label="费用描述">{{item.expense_detail}}</c-field>
					<c-field>
						<c-file-list :value="item.voucher_images"></c-file-list>
					</c-field>
				</detail-card>
			</c-field>
			<c-field label="收款人">{{baseInfo.payee_name}}</c-field>
			<c-field label="开卡行及支行">{{baseInfo.payee_bank_name}}</c-field>
			<c-field label="银行卡号">{{baseInfo.payee_card_no}}</c-field>
			<c-field label="备注">{{baseInfo.remarks}}</c-field>
		</doc-content>

		<doc-log ref="docLog" :form-id="baseInfo.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			flow="3"
			:order="id"
			:status="baseInfo.status"
			:applicant="baseInfo.is_founder == 1"
			:approver="baseInfo.is_approval == 1"
			@edit="mp.navigateWeb('/finance/reimb/edit', {id: baseInfo.id})"
			@delete="deleteHandle"
			@update="update"
		></doc-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/expense/reimbursement/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, transaction}) => {
						this.baseInfo = detailInfo;
						this.$refs.docHandle.init(transaction);
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/expense/reimbursement/delete',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>